import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CampaignProviderType } from '../../iModels/iCRMModels/campaign.model';

export interface IMockMessagingProvider {
  id: number;
  name: string;
  providerType: CampaignProviderType;
}

export interface IMockMessagingTemplate {
  id: number;
  providerId: number;
  name: string;
  content: string;
}

// static provider/template lists used ONLY for SMS & Notification — the messaging swagger
// has no backend endpoints for these channels yet; replace with real API calls once available.
const SMS_PROVIDERS: IMockMessagingProvider[] = [
  { id: 1, name: 'Ziplingo', providerType: 'ZIPLINGO' },
  { id: 2, name: 'Twilio', providerType: 'TWILIO' },
  { id: 3, name: 'Airtel', providerType: 'AIRTEL' }
];

const NOTIFICATION_PROVIDERS: IMockMessagingProvider[] = [
  { id: 1, name: 'Firebase', providerType: 'FIREBASE' },
  { id: 2, name: 'OneSignal', providerType: 'ONESIGNAL' }
];

const SMS_TEMPLATES: IMockMessagingTemplate[] = [
  { id: 1, providerId: 1, name: 'Welcome Offer', content: 'Welcome! Enjoy 10% off your next visit.' },
  { id: 2, providerId: 1, name: 'Birthday Wish', content: 'Happy Birthday! Here is a special gift for you.' },
  { id: 3, providerId: 2, name: 'Reminder', content: 'Reminder: your reward points are about to expire.' },
  { id: 4, providerId: 3, name: 'Announcement', content: 'We have an exciting new offer waiting for you!' }
];

const NOTIFICATION_TEMPLATES: IMockMessagingTemplate[] = [
  { id: 1, providerId: 1, name: 'New Offer', content: 'Check out our latest offer!' },
  { id: 2, providerId: 2, name: 'Reminder', content: 'You have unused reward points.' }
];

@Injectable({
  providedIn: 'root'
})
export class MessagingProviderService {
  getProviderType(channelType: 'SMS' | 'Notification', providerId: string | number): CampaignProviderType | null {
    const providers = channelType === 'SMS' ? SMS_PROVIDERS : NOTIFICATION_PROVIDERS;
    const provider = providers.find(item => String(item.id) === String(providerId));
    return provider ? provider.providerType : null;
  }

  getProviders(channelType: 'SMS' | 'Notification'): Observable<IMockMessagingProvider[]> {
    return of(channelType === 'SMS' ? SMS_PROVIDERS : NOTIFICATION_PROVIDERS);
  }

  getTemplates(channelType: 'SMS' | 'Notification', providerId: number): Observable<IMockMessagingTemplate[]> {
    const templates = channelType === 'SMS' ? SMS_TEMPLATES : NOTIFICATION_TEMPLATES;
    return of(templates.filter((t) => t.providerId === providerId));
  }
}
